module.exports = __webpack_public_path__ + "assets/e793675d337dafd01b2c0d0fc601ee3b.svg";